import React, { ChangeEvent } from "react";

type TextAreaProps = {
  placeholder?: string;
  value: string | undefined;
  onChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  note?: string;
}

type TextAreaBoxProps = {
  label: string;
  placeholder?: string;
  value: string | undefined;
  onChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  required?: boolean;
  note?: string;
}

export const TextArea: React.FC<TextAreaProps> = ({ placeholder, value, onChange, note }) => (
  <div className="contact-box__ct">
    <textarea className="input textarea" placeholder={placeholder} value={value} onChange={onChange} />
    <p className="contact-box__note">{note}</p>
  </div>
);

export const TextAreaBox: React.FC<TextAreaBoxProps> = ({ label, placeholder, value, onChange, required = false, note }) => (
  <div className="contact-box__item contact-box__item--start">
    <label className="contact-box__ttl">
      <span>{label}</span>
      { required && <small>必須</small> }
    </label>
    <TextArea placeholder={placeholder} value={value} onChange={onChange} note={note} />
  </div>
);
